import styled from '@emotion/styled';

export const LegalPersonViewPageContentContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const LegalPersonViewPageContentHeaderButtons = styled.section`
  display: flex;
  margin-bottom: 1rem;
  button {
    width: auto;
    margin-right: 16px;
  }
`;

export const LegalPersonViewPageContentTabsArea = styled.div`
  margin-top: 32px;
  margin-left: -10px;
`;
